import { StyledCard, StyledRow } from '@/shared/styles';
import styled from 'styled-components';

export const StyledScoreCard = styled(StyledCard)`
  border: 1px solid ${(props) => props.theme.marginsColor};
  color: ${(props) => props.theme.textColor};
  font-size: 16px;
  font-weight: 400;
  width: 100%;
  padding: 24px;
  align-items: start;
  height: auto;

  h3 {
    font-size: 16px !important;
    font-weight: 400 !important;
  }
`;

export const StyledScore = styled(StyledRow)`
  gap: 12px;
  font-size: 24px;
  font-weight: 600;
`;
